<script>
  export default {
    props: {
      artists: {
        type: Array,
        required: true
      },
      galleryId: {
        type: Number,
        required: true
      }
    },
    computed: {
      galleryArtists() {
        return this.artists.filter(artist => artist.WorksOnViewCount > 0);
      }
    },
    methods: {
      getWorksOnViewText(artist) {
        const worksCount = artist.WorksOnViewCount;
        return worksCount === 1 ? '1 work on view' : `${worksCount} works on view`;
      }
    },
  };
</script>

<template>
  <section>
    <h2
      class="
        $color/gray:767
        $typography/size:medium color
        layout/padding:left:page
        layout/padding:right:page
        typography"
      >
      Select artists in this gallery
    </h2>
    <ul
      class="
        @600/layout/padding:bottom:cap:2
        layout/flex
        layout/grid:gap:column:page:0.5
        layout/margin:top:page
        layout/padding:bottom:cap
        layout/padding:left:page
        layout/padding:right:page
        layout/scroll:horizontal
        width:100%"
      >
      <li
        v-for="artist in galleryArtists"
        :key="artist.ArtistId"
        >
        <a
          data-gtm="dvg-map-artist" 
          :href="`/artists/${artist.ArtistId}`" 
          class="
            layout/margin:top:clear
            link/focus
          "
          >
          <div
            class="
              @600/layout/width
              layout/width
            "
            style="
              --600--layout--width: 198px;
              --layout--width: 144px;
            "
            >
            <p
              class="
                $typography/size:large
                typography"
              >
              {{ artist.ArtistName }}
            </p>
            <p
              class="
                $color/gray:767
                $typography/size:medium
                $typography/weight:regular
                color layout/margin:top:cap
                typography
              "
              >
              {{ getWorksOnViewText(artist) }}
            </p>
          </div>
        </a>
      </li>
    </ul>
  </section>
</template>